import { tickerItems } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const levelStyle: Record<string, string> = {
  高风险: "bg-primary-100 text-primary-700 ring-primary-200",
  中风险: "bg-accent-100 text-accent-800 ring-accent-200",
  关注: "bg-secondary-100 text-secondary-800 ring-secondary-200",
};

export default function RiskTicker() {
  const marquee = [...tickerItems, ...tickerItems];

  return (
    <section id="risk-flash" className="w-full border-b border-background-200 bg-background-50 py-10 md:py-14">
      {/* marquee strip */}
      <div className="mb-8 flex w-full items-center overflow-hidden border-y border-background-200 bg-foreground-950">
        <div className="z-10 flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-3 text-xs font-bold text-background-50 md:px-6 md:text-sm">
          <span className="h-2 w-2 animate-pulseDot rounded-full bg-background-50"></span>
          实时
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center">
            {marquee.map((item, i) => (
              <span
                key={`${item.time}-${i}`}
                className="flex items-center gap-3 whitespace-nowrap px-6 text-xs text-background-200 md:text-sm"
              >
                <span className="text-accent-400">{item.time}</span>
                <span className="text-background-50">{item.text}</span>
                <span className="text-background-600">/</span>
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <SectionHeading
          no="01"
          title="实时风险速报"
          desc="按分钟汇聚的短讯条，只保留可核查的时间、主体与动作，方便你在碎片时间里快速扫一遍今天的风险面。"
          actionLabel="进入速报流"
          actionHref="#risk-flash"
        />

        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          {tickerItems.map((item, idx) => (
            <article
              key={`${item.time}-${idx}`}
              className="group flex items-start gap-3 rounded-lg border border-background-200 bg-background-100/60 p-4 transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              <span className="flex w-12 shrink-0 flex-col items-center">
                <span className="font-heading text-sm font-bold text-foreground-900">{item.time}</span>
                <span
                  className={`mt-1.5 rounded-sm px-1.5 py-0.5 text-[10px] font-semibold ring-1 ${levelStyle[item.level]}`}
                >
                  {item.level}
                </span>
              </span>
              <p className="flex-1 text-sm leading-relaxed text-foreground-800 group-hover:text-foreground-950">
                {item.text}
              </p>
              <i className="ri-arrow-right-s-line mt-0.5 w-5 h-5 flex items-center justify-center text-lg text-foreground-300 transition-colors group-hover:text-primary-500"></i>
            </article>
          ))}
        </div>

        <p className="mt-5 flex items-center gap-2 text-[11px] text-foreground-500">
          <i className="ri-information-line w-4 h-4 flex items-center justify-center"></i>
          速报仅整理公开讨论与行业反馈中的可观察信号，不代表对任何主体的事实认定。
        </p>
      </div>
    </section>
  );
}